const CONFIG = {
    baseURL: 'https://voiceboost.ai',
    // baseURL: 'http://192.168.18.205:5000',
  };
  
  export default CONFIG;